import React from "react";
import moment from "moment";
import { useApplication } from "../../contexts/ApplicationContext";

const HeaderQuery = ({
  title,
  type = "default",
  hasHeader = "true",
  date = "",
}) => {
  const { user } = useApplication();

  let logoSrc;

  switch (true) {
    case window.location.href.includes("datacredi"):
      logoSrc = "/assets/data-credi/logo.png";
      break;
    case window.location.href.includes("nexusid"):
      logoSrc = "/assets/nexus-id/logo.png";
      break;
    default:
      logoSrc = "/assets/logo_avalie.png";
      break;
  }

  return (
    <>
      {hasHeader === "true" && (
        <>
          <div
            className={`flex flex-row justify-between text-end gap-2 -mt-2 mb-1 items-center`}
          >
            {user?.Company?.showLogo && <img src={logoSrc} className="w-32" />}
            <div>
              <div className="font-semibold">{title}</div>
              <div className="text-sm text-end">
                <span>Data | Hora: </span>
                {date !== ""
                  ? date
                  : `${moment(moment()).format("DD/MM/yyyy | HH:mm")}h`}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HeaderQuery;
